export const SET_ALL_CATEGORIES = 'SET_ALL_CATEGORIES';
export const SET_ALL_EXPENSES = 'SET_ALL_EXPENSES';
export const ADD_NEW_CATEGORY = 'ADD_NEW_CATEGORY';
export const SET_SAVING = 'SET_SAVING';
export const SET_EXPENSE = 'SET_EXPENSE';
export const SET_MTD_EXPENSE_TOTAL = 'SET_MTD_EXPENSE_TOTAL';
export const SET_MTD_TRANSACTIONS = 'SET_MTD_TRANSACTIONS';
export const RESET_MTD_TRANSACTIONS = 'RESET_MTD_TRANSACTIONS';
export const SET_DATA_READY = 'SET_DATA_READY';
export const SET_SELECT_TRX = 'SET_SELECT_TRX';
